import { Type, Component } from '@angular/core';
import { SiteComponent } from './components/site/site.component';
import { PeopleComponent } from './components/people/people.component';
import { ToolEquipmentComponent } from './components/tool-equipment/tool-equipment.component';
import { AddressComponent } from './components/address/address.component';
import { SoftwareComponent } from './components/software/software.component';
import { InternalComponent } from './components/internal/internal.component';
import { OtherDocumentComponent } from './components/other-document/other-document.component';
import { LoanWheelInventoryComponent } from './components/loan-wheel-inventory/loan-wheel-inventory.component';
import { BankComponent } from './components/bank/bank.component';
import { EhsQuestionnaireComponent } from './components/ehs-questionnaire/ehs-questionnaire.component';
import { EinvoicingChannelsComponent } from './components/einvoicing-channels/einvoicing-channels.component';
import { EdiStatusComponent } from './components/edi-status/edi-status.component';

export class AccessRole {
    static Supplier = "Supplier";
    static Tesla = "Tesla";
    static All = "All";
}

export class ControlType {
    static Field = "Field";
    static Section = "Section";
    static Tab = "Tab";
}

export class TabItem {
    constructor(public component: Type<Component>, public data: any) { }
}

export const profileComponentMap: Map<string, TabItem> = new Map([
    ['Address', new TabItem(<Type<Component>>AddressComponent, { supplierCode: '' })],
    ['Site', new TabItem(<Type<Component>>SiteComponent, { supplierCode: '' })],
    ['Contacts', new TabItem(<Type<Component>>PeopleComponent, { supplierCode: '' })],
    ['Tool', new TabItem(<Type<Component>>ToolEquipmentComponent, { supplierCode: '', role: 'tool' })],
    ['Equipment', new TabItem(<Type<Component>>ToolEquipmentComponent, { supplierCode: '', role: 'equipment' })],
    ['Software', new TabItem(<Type<Component>>SoftwareComponent, { supplierCode: '' })],
    ['Internal', new TabItem(<Type<Component>>InternalComponent, { supplierCode: '' })],
    ['Document', new TabItem(<Type<Component>>OtherDocumentComponent, { supplierCode: '' })],
    ['Loaner Wheel Inventory', new TabItem(<Type<Component>>LoanWheelInventoryComponent, { supplierCode: '' })],
    ['Bank', new TabItem(<Type<Component>>BankComponent, { supplierCode: '' })],
    ['EHS Questionnaire', new TabItem(<Type<Component>>EhsQuestionnaireComponent, { supplierCode: '' })],
    ['EInvoicing', new TabItem(<Type<Component>>EinvoicingChannelsComponent, { supplierCode: '' })],
    ['EDI Status', new TabItem(<Type<Component>>EdiStatusComponent, { supplierCode: '' })],
]);

export class TabConfig {
    /* Control Type - Tab, Section, Field */
    constructor(public name: string,
        public controlType: string,
        public role: string,
        public supplierTypes: string[] | string,
        public supplierCategories: number[],
        public tierLevel: string ) { }
}
